import * as z from "zod";

export const conciergeSkillsSchema = z.object({
  backInStockNotifications: z.object({ enabled: z.boolean() }),
  cancelOrder: z.object({
    enabled: z.boolean(),
    cancelOrderTimeWindowAfterPlacingMinutes: z.number(),
  }),
  editAddress: z.object({
    enabled: z.boolean(),
    updateOrderAddressTimeWindowAfterPlacingMinutes: z.number(),
  }),
  updateOrder: z.object({
    enabled: z.boolean(),
    updateOrderTimeWindowAfterPlacingMinutes: z.number(),
  }),
  cartEditing: z.object({ enabled: z.boolean() }),
  createDiscountCode: z.object({
    enabled: z.boolean(),
    maxDiscountPercentage: z.number(),
    discountCodeExpirationMinutes: z.number(),
  }),
  productBundle: z.object({
    enabled: z.boolean(),
    maxDiscountPercentage: z.number(),
    discountCodeExpirationMinutes: z.number(),
  }),
  productVisualization: z.object({ enabled: z.boolean() }),
  webScrapingForProductInformation: z.object({ enabled: z.boolean() }),
  forceUseRetrieveSupportKnowledge: z.object({ enabled: z.boolean() }),
  returnsPortalLinkOverride: z.object({ url: z.string() }),
});

export interface ConciergeSkillsSettings extends z.infer<
  typeof conciergeSkillsSchema
> {}
